export interface ITextInputProps
	extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'type' | 'height'> {
	name: string;
	error?: string;
}

export const detectLayout = (character: string) => {
	character = character.toLowerCase();
	if (/^[A-Za-z]+$/.test(character)) {
		return 'en';
	} else if (/^[А-Яа-яЁё]+$/.test(character)) {
		return 'ru';
	}

	return '';
};
